export default "__VITE_ASSET__fOYSpC23__"